import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const DevisPage = lazy(() => import('../pages/devis/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RdvPage = lazy(() => import('../pages/rdv/page'));
const ZonePage = lazy(() => import('../pages/zone/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
import CGVPage from '../pages/cgv/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/devis',
    element: <DevisPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/rdv',
    element: <RdvPage />,
  },
  {
    path: '/zone',
    element: <ZonePage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/cgv',
    element: <CGVPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
